export default __webpack_public_path__ + "static/media/desktop-step4b.701750d0.png";